
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import api from "~api";
export default {
name: "noticeApply",
components: {
XHeader,Group,Cell,XAddress,Datetime,Selector,XTextarea,XInput,XButton,Toast
},
data(){
return{
title: "申请转专业",
yxxx:'',
newdept:[],
newmajor:[],
showtoast:false,
toasttext:'',
a: '',
b: '',
c: '',
}
},
mounted(){
this.getList();
},
methods:{
getList(){
const _this = this
let parms = {
"stuCode": window.localStorage.getItem("stuCode"),
"deptIdNew":""
}
api.post('/api/changeMajor/findStuInfo',parms).then(function (response) {
console.log(response)
if(response.status===200){
_this.yxxx = response.data.data.stuInfo
response.data.data.dept.map((item)=>{
_this.newdept.push({
key:item.deptIdNew,
value:item.deptNameNew
})
})
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
},
backPage(){
this.$router.push({name:'applicationProfessionalTransfer'})
},
checkJob(){
const _this = this
_this.newmajor=[]
_this.a = ''
let parms = {
"stuCode": window.localStorage.getItem("stuCode"),
"deptIdNew":_this.b
}
api.post('/api/changeMajor/findStuInfo',parms).then(function (response) {
console.log(response)
if(response.status===200){
response.data.data.major.map((item)=>{
_this.newmajor.push({
key:item.majorIdNew,
value:item.majorNameNew
})
})
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
},
onSubmit(){
const _this = this
console.log(_this.c.length)
if(_this.a===''){
this.toasttext = "请选择意向专业";
this.showtoast=true;
return false;
}










else {
let parms = {
"stuCode": window.localStorage.getItem("stuCode"),
"remark":_this.c,
"majorIdOld":_this.yxxx.majorIdOld,
"majorIdNew":_this.a
}
api.post('//api/changeMajor/insert',parms).then(function (response) {
if(response.status===200){
if(response.data.result===1){
_this.$msgbox('温馨提示：','添加成功');
_this.$router.push({name:'applicationProfessionalTransfer'})
}else {
_this.$msgbox('温馨提示：','添加失败');
}

}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/noticeApply.vue